<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Recipes and Everyday Knowledge</h1>
<h1 class="bk1">Medicine, Science, and the Household in Early Modern England</h1>
<p class="bkau">ELAINE LEONG</p>
<p class="bkpub">THE UNIVERSITY OF CHICAGO PRESS</p>
<p class="bkpub1">CHICAGO AND LONDON</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chi-Leong-0003.vue?71b72e4e